module.exports = __webpack_public_path__ + "static/media/img_sendero.f3b84d90.jpg";